import getStore from '../store/store';
/**
 * Gets current state of shared calendar options store
 */
export default function () {
    return getStore().currentState;
}
//# sourceMappingURL=getCalendarSharingCurrentState.js.map